import React, { useState, useEffect } from 'react';
import { Grid, FormControl, Select, MenuItem, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { PhotoLibrary, VideoLibrary } from '@mui/icons-material';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { PermissionGuard } from '../../components/PermissionGuard';
import VideoUpload from './VideoUpload';
import VideoList from './VideoList';
import ImageUpload from './ImageUpload';
import ImageList from './ImageList';
import FileManager from './FileManager/FileManager';

const Media = () => {
    const menuDispatch = useDispatch();
    const [mediaType, setMediaType] = useState('video');
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media-all'
        });
    }, [menuDispatch]);

    const handleMediaTypeChange = (event) => {
        setMediaType(event.target.value);
    };

    const handleUploadSuccess = () => {
        // Trigger refresh of the list
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <PageHeaderLayout headerTitle={'File Manager'}>
                
            </PageHeaderLayout>
            <FileManager/>
        </>
    );
};

export default Media;
